<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'
import { BRAND_CONTACTS } from '@/constants/brands'

const { showModal, hideModal } = useRenewalTooCloseErrorModal()

const policyStore = usePolicyStore()
const { selectedPolicy } = storeToRefs(policyStore)
const { formatPhoneNumber } = useFormat()

const phoneNumber = computed(() => {
  const brand = selectedPolicy.value?.brand?.toLowerCase() as keyof typeof BRAND_CONTACTS | undefined
  return (brand && BRAND_CONTACTS[brand]?.phone) || BRAND_CONTACTS.embrace.phone
})

const goToHome = () => {
  hideModal()
  navigateTo('/home')
}
</script>

<template>
  <UIDialog
    v-model="showModal"
    size="md"
    :hide-close-button="true"
    :hide-title="true"
  >
    <div class="pt-5 pb-0 text-center">
      <div class="flex justify-center mb-2">
        <ExclamationTriangleIcon
          class="w-[28px] h-[28px]"
          style="color: #cc413d"
        />
      </div>
      <h2 class="text-xl font-bold text-gray-900 mb-2">Your policy is almost ready to renew</h2>
      <div class="mb-2">
        <p
          class="text-[16px] font-normal leading-tight"
          style="color: #343434"
        >
          Your policy is within 5 days of renewal, so coverage updates can't be completed online. Please contact us at
          <a
            :href="`tel:${phoneNumber}`"
            class="text-primary underline underline-offset-4"
          >
            {{ formatPhoneNumber(phoneNumber) }}
          </a>
          and we can assist you.
        </p>
      </div>
    </div>
    <template #actions>
      <Button
        color="primary"
        rounded="full"
        class="px-[35px] py-2 mb-5 mt-0"
        @click="goToHome"
      >
        Back to home
      </Button>
    </template>
  </UIDialog>
</template>
